import { FC, Fragment, useContext, useEffect, useState } from 'react';
import FormGroup from 'components/ui/FormGroup/FormGroup';
import { Select } from 'ts/interfaces/Generic';
import SelectCustom from 'components/ui/SelectCustom/SelectCustom';
import { useTranslation } from 'react-i18next';
import { MainContext } from 'contexts/MainContext';

interface OrderTripCompanyProps {
  companyId: string;
  tripId: string;
  onChangeCompanyId: (companyId: string) => void;
  onChangeTripId: (tripId: string) => void;
}

const OrderTripCompany: FC<OrderTripCompanyProps> = (props) => {
  const { user, showOrderCompanyId, showOrderTripId } = useContext(MainContext);
  const { t } = useTranslation();
  const [showCompanyId, setShowCompanyId] = useState(false);
  const [disabledCompanyId, setDisabledCompanyId] = useState(false);
  const [optionsCompanyId, setOptionsCompanyId] = useState<Select[]>([]);

  useEffect(() => {
    if (user) {
      if (user.isAuth) {
        setShowCompanyId(true);
      }

      if (!user.branch?.sbr_pcc.includes('LOGIC:')) {
        setDisabledCompanyId(true);
        props.onChangeCompanyId('PRVT');
      } else {
        const newOptions: Select[] = user.branch?.sbr_pcc
          .replace('LOGIC:', '')
          .split(',')
          .map((item) => ({ value: item, label: item }));

        setOptionsCompanyId(newOptions);
        props.onChangeCompanyId(newOptions[0].value as string);
      }
    }
  }, [user]); // eslint-disable-line

  return (
    <div>
      {((showOrderCompanyId && showCompanyId) || showOrderTripId) && (
        <Fragment>
          <div className="divider mb-20 mt-10"></div>

          <div className="display-flex flex-wrap">
            {showCompanyId && showOrderCompanyId && (
              <div className="col-md-4 col-12">
                <div className="mb-5">{t('hotel.company_id')}</div>
                {disabledCompanyId ? (
                  <SelectCustom
                    options={[{ value: 'PRVT', label: 'PRVT' }]}
                    value={'PRVT'}
                    onChange={() => {}}
                    disabled={disabledCompanyId}
                    isDropdown={true}
                  />
                ) : (
                  <SelectCustom
                    options={optionsCompanyId}
                    value={props.companyId}
                    onChange={props.onChangeCompanyId}
                  />
                )}
                <div className="mb-20"></div>
              </div>
            )}
            {showOrderTripId && (
              <FormGroup
                className="col-md-8 col-12"
                value={props.tripId}
                onChange={props.onChangeTripId}
                label={t('hotel.backoffice_trip')}
                allowOnlyNumbers={true}
                maxLength={11}
              />
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default OrderTripCompany;
